import React from "react";
import { Column, ColumnMultipleValue, ColumnSingleValue } from "./dataTable.common";
import { safebind } from "../helpers";
import { CheckBox } from "./checkBox2";
import { TextInput } from "./textInput";
import _ from "lodash";
import { DropDownContainer } from "./dropDownMenu";
import StringsHelper from "../stringsHelper";

export interface HeaderFieldProps<T> {
  column: Column<T>;
  columnKey: string;
  onChangeOrder: (column: Column<T>, ascending: boolean) => void;
  onAddGrouping: (column: Column<T>) => void;
  onRemoveGrouping: () => void;
  orderStatus: { column: Column<T> | undefined; ascending: boolean };
  groupsStatus: Column<T>[];
  visibleElements: T[];
  allElements: T[];
  fixedHeaderColumnMinWidth?: number;
  filteredValues: any[];
  onChangeFilter: (column: Column<T>, value: (ColumnSingleValue)[], selected: boolean) => void;
}

interface HeaderFilterState {
  filterText: string;
}

export class HeaderField extends React.Component<HeaderFieldProps<any>, HeaderFilterState> {

  private orderAscending: () => void;
  private orderDescending: () => void;
  private cancelOrdering: () => void;
  private addGrouping: () => void;
  private cancelGrouping: () => void;

  constructor(props: HeaderFieldProps<any>) {
    super(props);
    this.state = {
      filterText: ""
    }
    this.assignCallbacks(props);
  }

  componentWillReceiveProps(nextProps: HeaderFieldProps<any>) {
    this.assignCallbacks(nextProps);
  }

  assignCallbacks = (props: HeaderFieldProps<any>) => {
    this.orderAscending = safebind(props.onChangeOrder, this, props.column, true);
    this.orderDescending = safebind(props.onChangeOrder, this, props.column, false);
    this.cancelOrdering = safebind(props.onChangeOrder, this, undefined, false);
    this.addGrouping = safebind(props.onAddGrouping, this, props.column);
    this.cancelGrouping = safebind(props.onRemoveGrouping, this, props.column);
  }

  onSelectFilterValue = (value: any, checked: boolean) => {
    this.props.onChangeFilter(this.props.column, [value], checked);
  }

  onChangeFilterText = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ filterText: e.target.value })
  }

  onSelectall = (checked: boolean) => {
    const values = this.getUniqueValues(this.props.allElements).map(x => x.key);
    this.props.onChangeFilter(this.props.column, values, checked);
  }


  private getUniqueValues = (elements: any[]) => {
    const filterTemplate = this.props.column.getFilterTemplate();
    const filterBy = this.props.column.getFilterBy();

    if (filterBy && filterTemplate) {
      let values: { key: ColumnSingleValue, value: ColumnSingleValue }[] = [];
      for (const e of elements) {
        const key = filterBy(e);
        const value = filterTemplate(e);

        if (!Array.isArray(key) && !Array.isArray(value) && key != null && value != null && value !== "") {
          values.push({ key: key, value: value })
        } else {
          const keys = key as ColumnMultipleValue;
          const vals = value as ColumnMultipleValue;
          for (const i in keys) {
            if (keys[i] != null && value != null && value !== "")
              values.push({ key: keys[i], value: vals[i] })
          }
        }
      }

      //const values = elements.map(e => { return { key: filterBy(e), value: filterTemplate(e) } });

      return _.uniqBy(values, v => v.key);
    }

    return [];
  }


  private isFiltering = () => {
    const { filteredValues } = this.props;
    return this.canFilter() && filteredValues.length > 0;
  }

  private canFilter = () => {
    const { column } = this.props;
    return column.canFilter() && (column.getFilterTemplate() != null);
  }

  getFilterElements = (elements: any[]) => {

    if (this.canFilter()) {

      const values = this.getUniqueValues(elements);

      if (!values.length)
        return null;

      const elems = values
        .filter(kv => this.state.filterText ? StringsHelper.contains(kv.value.toString(), this.state.filterText) : true)
        .sort((a, b) => (a?.value?.toString() || "").localeCompare(b?.value?.toString() || ""))
        .map((kv, i) => {
          const checked = this.props.filteredValues.indexOf(kv.key) < 0;
          return (<div className="m-1" key={`filterSelector_${i}_${kv.value}`}>
            <CheckBox
              name={`filterSelector_${i}_${kv.value}`}
              className={"text-truncate d-inline-block"}
              title={kv.value.toString()}
              label={kv.value.toString()}
              checked={checked}
              onChange={safebind(this.onSelectFilterValue, this, kv.key)}
            />
          </div>);
        });

      return (<>
        <div className="dropdown-divider"></div>
        <form className="p-1" >
          <div className="">
            <TextInput
              name="filter"
              placeholder="Cerca"
              onChange={this.onChangeFilterText}
              value={this.state.filterText}
              style={{ fontSize: "0.9em" }}
            >
              <span className="input-group-text">
                <i className="fa fa-search" />
              </span>
            </TextInput>
          </div>

          <div className="" style={{ maxHeight: 400, width: 200, overflowY: "auto", overflowX: "hidden" }}>
            {elems}
          </div>
          <div className="m-1">
            <a className="small text-info d-inline me-2" onClick={safebind(this.onSelectall, this, true)}><u>Seleziona tutto</u></a>
            <a className="small text-info d-inline" onClick={safebind(this.onSelectall, this, false)}><u>Cancella</u></a>
          </div>
        </form>
      </>)
    }

    return null;
  }

  render() {
    const { column, orderStatus, visibleElements: elements } = this.props;
    const canGroup = column.canGroup();
    const canOrder = column.canOrder();
    const canFilter = this.canFilter();
    const commands = column.getCommands();

    const headerstyle: React.CSSProperties | undefined = this.props.fixedHeaderColumnMinWidth
      ? {
        minWidth: this.props.fixedHeaderColumnMinWidth,
      }
      : undefined;



    let th;
    if (!canGroup && !canOrder && !canFilter && commands.length === 0)
      th = <div style={headerstyle} title={column.getTitle()} key={`divcol_${this.props.columnKey}`}>{column.getHeader(elements)}</div>;
    else {
      let orderArrow: React.ReactElement<any> | null = null;
      if (orderStatus.column && orderStatus.column.getHeader(elements) === column.getHeader(elements)) {
        orderArrow = (<i
          className={orderStatus.ascending
            ? "fas fa-arrow-down text-info ms-1"
            : "fas fa-arrow-up text-info ms-1"}
          aria-hidden="true"
        />);
      }

      let headerIconClasses = "";
      if (canFilter) {
        headerIconClasses = `fas fa-filter align-middle fa-xs ${this.isFiltering() ? "text-primary" : ""}`;
      } else {
        headerIconClasses = `fas fa-sort-down align-top`;
      }

      th = (
        <DropDownContainer>
          {
            toggle => <div className="dropdown" style={headerstyle} >
              <div
                className="dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
                style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                onClick={toggle}
              >
                <span title={column.getTitle()}>{column.getHeader(this.props.visibleElements)} <i className={headerIconClasses}></i></span>
                {orderArrow}
                <span className={"caret d-print-none" + (commands.length > 0 ? " text-danger" : "")} />
              </div>
              <div className="dropdown-menu">
                <div style={{ display: canOrder && (!orderStatus.ascending || !orderStatus.column) ? "" : "none" }}
                  className="dropdown-item"
                  onClick={this.orderAscending}>
                  <a><span className="fa fa-arrow-down" aria-hidden="true" /> Ordina Crescente</a>
                </div>
                <div style={{ display: canOrder && (orderStatus.ascending || !orderStatus.column) ? "" : "none" }}
                  className="dropdown-item"
                  onClick={this.orderDescending}>
                  <a><span className="fa fa-arrow-up" aria-hidden="true" /> Ordina Decrescente</a>
                </div>
                <div style={{ display: canOrder && orderStatus.column ? "" : "none" }}
                  className="dropdown-item"
                  onClick={this.cancelOrdering}>
                  <a><span className="fa fa-undo" aria-hidden="true" /> Elimina ordinamento</a>
                </div>
                <div style={{ display: canGroup && this.props.groupsStatus.indexOf(column) < 0 ? "" : "none" }}
                  className="dropdown-item"
                  onClick={this.addGrouping}>
                  <a><i className="far fa-object-group" aria-hidden="true" />{" "} Raggruppa</a>
                </div>
                <div style={{ display: canGroup && this.props.groupsStatus.indexOf(column) > -1 ? "" : "none" }}
                  className="dropdown-item"
                  onClick={this.cancelGrouping}>
                  <a><span className="far fa-object-group" aria-hidden="true" />{" "} Elimina raggruppamento</a>
                </div>
                {
                  commands.map((x, index) => (
                    <li key={index}
                      className="dropdown-item"
                    >
                      {(x as any).type === "a" ? x : <span style={{ padding: "3px 20px" }}>{x}</span>}
                    </li>
                  ))
                }
                {this.getFilterElements(this.props.allElements)}
              </div>
            </div>
          }
        </DropDownContainer>
      );
    }

    return (
      <th
        className={column.props.headerClassName}
        style={column.props.headerStyle} key={this.props.columnKey}
      >
        {th}
      </th>
    );
  }
}
